import React from 'react';
import UsersGroupRow from './UsersGroupRow';

const UsersGroupsTableRows = ({
  allowRead,
  allowRemove,
  category,
  items,
  removeGroup,
  user,
}) => {
  const lastItem = items.length - 1;

  return (
    items?.map((item, i) => (
      <UsersGroupRow
        allowRead={allowRead}
        allowRemove={allowRemove}
        category={category}
        key={`users_group_table_row_${item.code}`}
        lastItem={i === lastItem}
        removeGroup={removeGroup}
        user={user}
        userGroup={item}
      />
    ))
  );
};

export default UsersGroupsTableRows;
